module.exports = __webpack_public_path__ + "img/pleasure-icon-5.ca29a67f.svg";